import React, { useState } from "react";
import { Button, InputItem, List, Icon } from 'antd-mobile';
import Permission from '../components/Permission';

import * as Api from "../../../api/usms";
import moment from 'moment';
import { AclKeys } from '../utils/permissions';
import { SendSigContent, SendTemplateId, SubmitResultSuccess } from '../utils/const';

import '../index.css';

// 发送短信默认的参数，用yonge.li的账号下的资源
const defaulPArams = {
    SigContent: SendSigContent,
    TemplateId: SendTemplateId,
}

// 最大获取记录循环次数
const MAX_CHECK_N = 10;

function SendMessage(props) {

    const [phoneNumber, setPhoneNumber] = useState();
    const [disabled, setDisabled] = useState(true);

    // 网关检测
    const [gwVisible, setGwVisible] = useState(false);
    const [gwLoading, setGwLoading] = useState(false);
    const [gwErrorMessage, setGwErrorMessage] = useState();
    // 发送API检测
    const [sendApiErrorMessage, setSendApiErrorMessage] = useState();
    const [sendApiDetail, setSendApiDetail] = useState();

    // 客户提交记录
    const [customerSubmitVisible, setCustomerSubmitVisible] = useState(false);
    const [customerSubmitLoading, setCustomerSubmitLoading] = useState(false);
    const [customerSubmitErrorMessage, setCustomerSubmitErrorMessage] = useState();
    const [customerSubmitDetail, setCustomerSubmitDetail] = useState();

    // 提交记录
    const [submitVisible, setSubmitVisible] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitErrorMessage, setSubmitErrorMessage] = useState();
    const [submitDetail, setSubmitDetail] = useState();

    // 回执记录
    const [reportVisible, setReportVisible] = useState(false);
    const [reportLoading, setReportLoading] = useState(false);
    const [reportErrorMessage, setReportErrorMessage] = useState();
    const [reportDetail, setReportDetail] = useState();

    const onChange = (e) => {
        const value = e;
        setPhoneNumber(value);
        setDisabled(!(value && value.length >= 11));
    }
    const resetStatus = () => {
        setGwVisible(false);
        setGwLoading(false);
        setGwErrorMessage();
        setSendApiErrorMessage();
        setSendApiDetail();
        setCustomerSubmitVisible(false);
        setCustomerSubmitLoading(false);
        setCustomerSubmitErrorMessage();
        setCustomerSubmitDetail();
        setSubmitVisible(false);
        setSubmitLoading(false);
        setSubmitErrorMessage();
        setSubmitDetail();
        setReportVisible(false);
        setReportLoading(false);
        setReportErrorMessage();
        setReportDetail();
    }

    const handleSend = () => {
        resetStatus();
        const data = {
            ...defaulPArams,
            PhoneNumbers: phoneNumber.split(",")
        }
        sendMessage(data);
    }

    const sendMessage = (data) => {
        setGwLoading(true);
        setGwVisible(true);
        Api.SendUSMSMessage(data).then(res => {
            setGwLoading(false);
            if (res.RetCode === 0) {
                setSendApiDetail(res);
                // 发送成功后拿到SessionNo获取提交结果
                getCustomerSubmitRecord(res.SessionNo);
            } else {
                setSendApiErrorMessage(res.Message);
            }
        }).catch(e => {
            setGwErrorMessage(e.message);
            setGwLoading(false);
        });
    }


    const getCustomerSubmitRecord = (TaskId, n = 0) => {
        setCustomerSubmitLoading(true);
        setCustomerSubmitVisible(true);
        const data = {
            TaskId: [TaskId],
            BeginTime: moment().subtract(10, "minutes").unix(),
            EndTime: moment().unix(),
        }
        Api.DescribeCustomerSubmitRecord(data).then(res => {
            if (res.Data && res.Data[0]) {
                setCustomerSubmitDetail(res.Data[0]);
                setCustomerSubmitLoading(false);
                // 获取到提交记录，继续下一步
                getSubmitRecord(res.Data[0].SessionId);
            } else {
                // 未获取到提交记录，时隔n*1s重新获取，循环10次，总计55s
                if (n < MAX_CHECK_N) {
                    setTimeout(() => getCustomerSubmitRecord(TaskId, n + 1), n * 1000);
                } else {
                    setCustomerSubmitErrorMessage("客户提交记录为空");
                    setCustomerSubmitLoading(false);
                }
            }
        }).catch(e => {
            setCustomerSubmitErrorMessage(e.message);
            setCustomerSubmitLoading(false);
        });
    }

    const getSubmitRecord = (SessionId, n = 0) => {
        setSubmitLoading(true);
        setSubmitVisible(true);
        const data = {
            SessionId: [SessionId],
            BeginSubmitTime: moment().subtract(10, "minutes").unix(),
            EndSubmitTime: moment().unix(),
        }
        Api.DescribeSubmitRecord(data).then(res => {
            if (res.Data && res.Data.length > 0) {
                // 客户配置的通道
                let customerChannelIds = [];
                if (customerSubmitDetail && customerSubmitDetail.ChannelId) {
                    customerChannelIds = customerSubmitDetail.ChannelId.split(",")
                }
                // 提交记录按时间排序
                const SubmitRecord = res.Data.sort((a, b) => a.CreateTime - b.CreateTime);
                // 提交记录可能有多个，当发送成功或者重试次数达配置通道总数，停止loading，继续下一步
                if (SubmitRecord[SubmitRecord.length - 1].SubmitResult === SubmitResultSuccess || SubmitRecord.length === customerChannelIds.length) {
                    setSubmitDetail(SubmitRecord);
                    setSubmitLoading(false);
                    // 获取到提交记录，继续下一步
                    getReportRecord(SessionId);
                } else {// 当发送失败时会根据客户配置的通道继续提交
                    if (n < MAX_CHECK_N) {
                        setTimeout(() => getSubmitRecord(SessionId, n + 1), n * 1000);
                    } else {
                        setSubmitErrorMessage("提交记录为空");
                        setSubmitLoading(false);
                    }
                }
            } else {
                // 未获取到提交记录，时隔n*1s重新获取，循环10次，总计55s
                if (n < MAX_CHECK_N) {
                    setTimeout(() => getSubmitRecord(SessionId, n + 1), n * 1000);
                } else {
                    setSubmitErrorMessage("提交记录为空");
                    setSubmitLoading(false);
                }
            }
        }).catch(e => {
            setSubmitErrorMessage(e.message);
            setSubmitLoading(false);
        });
    }

    // 查询短信回执&上行记录
    const getReportRecord = (SessionId, n = 0) => {
        setReportLoading(true);
        setReportVisible(true);
        const data = {
            SessionId: [SessionId],
            BeginReportTime: moment().subtract(10, "minutes").unix(),
            EndReportTime: moment().unix(),
        }
        Api.DescribeReportRecord(data).then(res => {
            if (res.RetCode === 0) {
                if (res.Data && res.Data[0]) {
                    setReportDetail(res.Data[0]);
                    setReportLoading(false);
                    if (!res.Data[0].ReceiptSuccess) {
                        setReportErrorMessage(`${res.Data[0].ReportResult}(${res.Data[0].ReportDesc})`);
                    }
                } else {
                    // 未获取到提交记录，时隔n*1s重新获取，只循环10次，总计55s
                    if (n < MAX_CHECK_N) {
                        setTimeout(() => getReportRecord(SessionId, n + 1), n * 1000);
                    } else {
                        setReportErrorMessage("提交记录为空");
                        setReportLoading(false);
                    }
                }
            } else {
                setReportErrorMessage(res.Message);
                setReportLoading(false);
            }
        }).catch(e => {
            setReportErrorMessage(e.message);
            setReportLoading(false);
        });
    }


    const CheckIcon = ({ checkLoading, checkErrorMessage }) => <div style={{ float: 'right' }}>
        {checkLoading ? <Icon type="loading" className="a-blue" /> :
            (checkErrorMessage ? <Icon type="cross-circle" className="u-red" /> : <Icon type="check-circle-o" className="u-green" />)}
    </div>

    const CheckListItem = ({ visible, title, detail, checkLoading, checkErrorMessage }) => {
        const [detailVisible, setDetailVisible] = useState(false);
        if (visible) {
            return <List.Item onClick={() => setDetailVisible(!detailVisible)}>
                <span>{title}</span>
                <CheckIcon checkLoading={checkLoading} checkErrorMessage={checkErrorMessage} />
                {detailVisible && detail && <pre className="little-description mt-4 text-pre" >{detail}</pre>}
                {checkErrorMessage ?
                    <div className="text-pre" style={{ textAlign: 'center', color: 'red', padding: '10px' }}>
                        {checkErrorMessage}
                    </div> : null}
            </List.Item>
        }
        return null
    }

    const renderSubmitDetail = submits => <div>
        {submits.map((item, index) => <div>[{index + 1}] 通道：{item.ChannelId}；提交结果：{item.SubmitResult}；结果描述：{item.SubmitDesc}；结果描述：{item.SubmitDesc}；</div>)}
    </div>

    const CheckOptions = [
        {
            visible: gwVisible,
            title: "网关",
            checkLoading: gwLoading,
            checkErrorMessage: gwErrorMessage
        },
        {
            visible: gwVisible,
            title: "API提交",
            detail: sendApiDetail && `ID:${sendApiDetail.SessionNo}`,
            checkLoading: gwLoading,
            checkErrorMessage: gwErrorMessage || sendApiErrorMessage
        },
        {
            visible: customerSubmitVisible,
            title: "客户提交记录",
            detail: customerSubmitDetail && `通道：${customerSubmitDetail.ChannelId}；`,
            checkLoading: customerSubmitLoading,
            checkErrorMessage: customerSubmitErrorMessage
        },
        {
            visible: submitVisible,
            title: "提交记录",
            detail: submitDetail && renderSubmitDetail(submitDetail),
            checkLoading: submitLoading,
            checkErrorMessage: submitErrorMessage
        },
        {
            visible: reportVisible,
            title: "回执记录",
            detail: reportDetail && `通道：${reportDetail.ChannelId}；回执结果：${reportDetail.ReportResult}；回执描述：${reportDetail.ReportDesc}；`,
            checkLoading: reportLoading,
            checkErrorMessage: reportErrorMessage
        },
    ]
    return <div className="container">
        <h3 className='mb-10'>短信发送检测：</h3>
        <Permission aclKey={AclKeys.SendMessageTool}>
            <InputItem
                value={phoneNumber}
                onChange={onChange}
                placeholder="请输入手机号码"
            >手机号</InputItem>
            <Button type="primary" style={{ marginTop: '10px' }} onClick={handleSend} disabled={disabled} loading={gwLoading}>发送</Button>
            <List renderHeader={() => "检测结果"} style={{ marginTop: '10px' }}>
                {gwVisible && CheckOptions.map((option, index) => <CheckListItem key={index} {...option} />)}
            </List>
        </Permission>
    </div>
}

export default SendMessage